(function () {

    'use strict';

    angular.module('tmx-app')
        .factory('menu', ['$state','$mdMedia','routes', '$auth', 'ServerExceptionService','UsersService','ToastService','cacheStore','lookupService',
            function ($state,$mdMedia, routes, $auth, ServerExceptionService, UsersService,ToastService,cacheStore,lookupService) {
                var self = {
                    sections: [],
                    level2:'',
                    pages: {},
                    isOpen:$mdMedia('gt-sm'),
                    showMargin:$mdMedia('gt-sm'),
                    title: 'LeftNavMenuHeading',
                    autoFocusContent: false,
                    toggleSelectSection: function (section) {
                        self.openedSection = (self.openedSection === section ? null : section);
            //$location.path(section.url);
                    },
                    isSectionSelected: function (section) {
                        return self.openedSection === section;
                    },
                    isSecondLeveLMenuSelected: function (section,levelName) {
                        return self.openedSection === section && levelName==self.level2;
                    },
                    istoggleSecondLevelMenu: function (levelName) {
                        self.level2=levelName;
                    },
                    changeState: function (state) {
                        $state.go(state, {}, { reload: true });

                    },
                    selectPage: function (page) {
            //After debugging $location service, do not forget to remove the href code from menulink directive
                        if (page.state == "logout") {
                            self.LogoutUser();
                        }
                        var route = routes.getRouteByName(page.name);
                        if (route == null) {
              //Make sure you have added the state which ends with this name in app config
                            return;
                        }
                        self.changeState(route.state);
                        self.currentPage = page;
                    }

                };

                self.LogoutUser = function(){
                    UsersService.logoutUser().then(function (response) {
                        if (response.status && response.status.code == 200) {
                            $auth.logout();
                            $state.transitionTo('public.login').then(function () {
                                localStorage.removeItem('LoggedInUserPrivileges');
                                cacheStore.removeAll();
                                lookupService.clearLocalLookups();
                                var error = "You have been Successfully Logged Out!";
                                ServerExceptionService.Displaymsg = ServerExceptionService.Displayfunction(error);
                                ToastService.showCustomToast("success", ServerExceptionService.Displaymsg);
                            });
                        }
                    });
                }


                return self;
            }
        ]);// factory end

})();//file end